import { render, staticRenderFns } from "./TelaSubGrupo.vue?vue&type=template&id=d3a18994&"
import script from "./TelaSubGrupo.vue?vue&type=script&lang=js&"
export * from "./TelaSubGrupo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports